import 'quasar/dist/quasar.styl';
import 'quasar-extras/material-icons.js';
import 'quasar-extras/fontawesome';

import Vue from 'vue';

import Quasar, {
  QAvatar,
  QBadge,
  QBanner,
  QBar,
  QBreadcrumbs,
  QBreadcrumbsEl,
  QBtn,
  QBtnDropdown,
  QBtnGroup,
  QBtnToggle,
  QCard,
  QCardActions,
  QCardSection,
  QCarousel,
  QCarouselControl,
  QCarouselSlide,
  QChatMessage,
  QCheckbox,
  QChip,
  QCircularProgress,
  QDate,
  QDialog,
  QDrawer,
  QEditor,
  QExpansionItem,
  QFab,
  QFabAction,
  QField,
  QFile,
  QFooter,
  QForm,
  QHeader,
  QIcon,
  QImg,
  QInfiniteScroll,
  QInnerLoading,
  QInput,
  QIntersection,
  QItem,
  QItemLabel,
  QItemSection,
  QLayout,
  QLinearProgress,
  QList,
  QMenu,
  QPage,
  QPageContainer,
  QPageScroller,
  QPageSticky,
  QPagination,
  QPopupProxy,
  QRadio,
  QRating,
  QRouteTab,
  QScrollArea,
  QSelect,
  QSeparator,
  QSkeleton,
  QSlideTransition,
  QSpace,
  QSpinner,
  QSpinnerClock,
  QSpinnerDots,
  QSpinnerFacebook,
  QSpinnerHourglass,
  QSplitter,
  QStep,
  QStepper,
  QStepperNavigation,
  QTab,
  QTable,
  QTabPanel,
  QTabPanels,
  QTabs,
  QTd,
  QTh,
  QTime,
  QToggle,
  QToolbar,
  QToolbarTitle,
  QTooltip,
  QTr,
  QTree,
  QUploader,
  QUploaderAddTrigger,
  QVideo,
  QVirtualScroll,
} from 'quasar/dist/quasar.esm';


Vue.use(Quasar, {
  components: [
    QLayout,
    QPageContainer,
    QPage,
    QHeader,
    QFooter,
    QDrawer,
    QPageSticky,
    QPageScroller,
    QToolbar,
    QToolbarTitle,
    QScrollArea,
    QBtn,
    QCard,
    QCardSection,
    QCardActions,
    QSeparator,
    QMenu,
    QItem,
    QList,
    QLinearProgress,
    QItemSection,
    QBtnDropdown,
    QIcon,
    QAvatar,
    QItemLabel,
    QForm,
    QInput,
    QToggle,
    QSpinnerHourglass,
    QSelect,
    QSplitter,
    QTabs,
    QTab,
    QTabPanels,
    QTabPanel,
    QRouteTab,
    QSpace,
    QExpansionItem,
    QTable,
    QTh,
    QTr,
    QTd,
    QPagination,
    QBadge,
    QDialog,
    QBar,
    QTooltip,
    QImg,
    QCarousel,
    QCarouselControl,
    QCarouselSlide,
    QVideo,
    QUploader,
    QVirtualScroll,
    QCheckbox,
    QSkeleton,
    QInfiniteScroll,
    QSpinnerDots,
    QIntersection,
    QSpinnerFacebook,
    QStepper,
    QStep,
    QRating,
    QStepperNavigation,
    QBtnToggle,
    QDate,
    QPopupProxy,
    QField,
    QRadio,
    QBtnGroup,
    QFile,
    QCircularProgress,
    QSpinner,
    QChip,
    QBreadcrumbs,
    QBreadcrumbsEl,
    QInnerLoading,
    QTree,
    QTime,
    QUploaderAddTrigger,
    QChatMessage,
    QFab,
    QFabAction,
    QSpinnerClock,
    QSlideTransition,
    QEditor,
    QBanner,
  ],
});
